import { render, staticRenderFns } from "./changepassword.vue?vue&type=template&id=35ce9160&scoped=true&"
import script from "./changepassword.vue?vue&type=script&lang=js&"
export * from "./changepassword.vue?vue&type=script&lang=js&"
import style0 from "./changepassword.vue?vue&type=style&index=0&id=35ce9160&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ce9160",
  null
  
)

export default component.exports